import { createContext, useContext, useEffect, useState } from "react";
import { de, fr } from "./i18n-de-fr";

const STRINGS = {
  it: {
    nav_servizi: "Servizi",
    nav_brand: "Brand",
    nav_recensioni: "Recensioni",
    nav_contatti: "Contatti",
    nav_faq: "FAQ",
    cta_prenota: "Prenota Visita",
    hero_overline: "Ottica · Ceglie Messapica",
    hero_l1: "Lo stile",
    hero_l2a: "incontra",
    hero_l2b: "la vista.",
    hero_sub: "Da oltre 13 anni l'ottica di riferimento nel cuore della Valle d'Itria: occhiali da sole e da vista, lenti per bambini e progressive. Via Cristoforo Colombo 40, Ceglie Messapica.",
    hero_cta1: "Prenota una visita",
    hero_cta_shop: "Scopri la Collezione",
    hero_cta2: "Scopri i servizi",
    hero_proof: "5,0 su Google · 35 recensioni",
    cfg_shape: "Montatura",
    cfg_color: "Colore",
    cfg_lens: "Lenti",
    shape_rotonda: "Rotonda",
    shape_squadrata: "Squadrata",
    shape_pantos: "Pantos",
    shape_aviator: "Aviator",
    shape_cateye: "Cat-eye",
    col_nero: "Nero",
    col_avana: "Avana",
    col_terracotta: "Terracotta",
    col_oliva: "Oliva",
    col_oro: "Oro",
    lens_cristallo: "Cristallo",
    lens_verde: "Verde",
    lens_ambra: "Ambra",
    lens_fume: "Fumé",
    lens_azzurra: "Azzurra",
    man_statement: "Occhiali per chi sceglie di essere unico.",
    man_highlight: "unico.",
    man_c1t: "Tredici anni sul territorio",
    man_c1d: "Da oltre tredici anni a Ceglie Messapica: un'ottica di riferimento dove professionalità ed empatia la fanno da padrone.",
    man_c2t: "Specialisti della vista",
    man_c2d: "Lenti oftalmiche per bambini con gestione certificata della miopia e lenti progressive per adulti: la vista a ogni età.",
    man_c3t: "Marchi e spazi scelti con cura",
    man_c3d: "La scelta dei marchi e dell'arredamento è il nostro punto di forza: tutto è pensato per chi vuole sentirsi unico.",
    man_alt: "Ritratto editoriale con occhiali da vista",
    cert_label: "Certificazioni",
    cert1t: "Centro Ottico Expert Specialist",
    cert2t: "Gestione della miopia certificata",
    srv_overline: "01 · I nostri servizi",
    srv_title: "Tutto per i tuoi occhi, in un unico posto.",
    srv1t: "Occhiali da sole",
    srv1d: "Collezioni adulto selezionate con cura: dai classici intramontabili alle ultime tendenze.",
    srv2t: "Occhiali da vista",
    srv2d: "Montature e lenti oftalmiche su misura, con attenzione assoluta alla precisione.",
    srv3t: "Lenti per bambini",
    srv3d: "Lenti oftalmiche per i più piccoli e gestione certificata della miopia con lenti Stellest.",
    srv4t: "Lenti progressive",
    srv4d: "Per adulti: passaggio fluido tra vicino e lontano, senza compromessi.",
    srv5t: "Consegna e ritiro",
    srv5d: "Consegna a domicilio o ritiro in negozio: come preferisci, senza attese.",
    srv_store_t: "Shopping in negozio",
    srv_store_d: "Vieni a trovarci: prova le montature con la consulenza dei nostri ottici. Visita veloce, senza impegno.",
    srv_store_alt: "Interno della boutique Stylottica Ceglie",
    stmt_label: "La nostra filosofia",
    stmt_w1: "Meglio",
    stmt_w2: "unici",
    stmt_w3: "che noiosi.",
    brand_overline: "02 · Brand & Stili",
    brand_title: "Le montature che ami, anche per i più giovani.",
    brand_sub: "Da Stylottica Ceglie trovi gli occhiali Police pensati per i teenager e tante altre proposte per ogni età e stile.",
    mq_sole: "Occhiali da Sole",
    mq_vista: "Occhiali da Vista",
    mq_contatto: "Lenti a Contatto",
    mq_teen: "Montature Teen",
    mq_nuove: "Nuove Collezioni",
    vet_overline: "03 · Vetrina",
    vet_title: "Le montature del momento.",
    vet_sub: "Una selezione dei modelli disponibili in negozio. Scegli una collezione e passa a provarli.",
    vet_all: "Tutte",
    vet_empty: "Nessun modello in questa collezione per ora. Torna presto a trovarci.",
    vet_add: "Aggiungi al carrello",
    vet_out: "Esaurito",
    vet_unavailable: "Non disponibile",
    vet_avail: "Disponibile in negozio",
    vet_last: "Ultimi {n} pezzi",
    vet_last1: "Ultimo pezzo",
    promo_label: "Promo in corso",
    promo_cta: "Approfittane in negozio",
    promo_valid: "Valida fino al",
    promo_da: "Valida dal",
    rev_overline: "04 · Dicono di noi",
    rev_caption: "Il punteggio pieno dei nostri clienti su Google",
    rev_stat1: "Google · 35 recensioni",
    rev_stat2: "Facebook · 46 recensioni",
    rev_stat3: "Follower su Facebook",
    rev_closing: "La fiducia dei nostri clienti è la nostra lente migliore. Passa a trovarci e scopri perché chi entra da Stylottica Ceglie torna sempre.",
    testimonials: [
      { text: "Professionalità e gentilezza rare. Mi hanno aiutata a scegliere la montatura perfetta per il mio viso.", name: "Maria G." },
      { text: "Occhiali pronti in pochissimo tempo e risultato impeccabile. Tornerò sicuramente.", name: "Giuseppe L." },
      { text: "Finalmente un ottico che ascolta davvero. Misurazione della vista accuratissima.", name: "Anna S." },
      { text: "Ho preso gli occhiali Police per mio figlio: è felicissimo e non li toglie mai.", name: "Francesca M." },
      { text: "Prezzi onesti, tanta scelta e consigli sinceri. Consigliatissimo.", name: "Marco P." },
      { text: "Ambiente elegante e personale super preparato. Il miglior ottico della zona.", name: "Lucia R." },
    ],
    con_overline: "07 · Contatti & Orari",
    con_directions: "Come arrivare",
    con_title: "Ti aspettiamo in negozio.",
    con_hours: "Orari di apertura",
    day_mon: "Lunedì",
    day_tuesat: "Martedì – Sabato",
    day_sun: "Domenica",
    mon_note: "Mattina chiuso",
    closed: "Chiuso",
    con_phone_note: "(anche WhatsApp)",
    con_form_t: "Scrivici un messaggio",
    con_form_s: "Per prenotare una visita o chiedere informazioni sulle collezioni.",
    ph_name: "Nome e cognome",
    ph_phone: "Telefono (facoltativo)",
    ph_msg: "Il tuo messaggio",
    btn_send: "Invia messaggio",
    btn_sending: "Invio in corso…",
    toast_ok: "Messaggio inviato! Ti ricontatteremo al più presto.",
    toast_err: "Errore nell'invio. Riprova o chiamaci allo 0831 19 81 780.",
    footer_tag: "Ottica a Ceglie Messapica. Via Cristoforo Colombo 40, 72013 (BR).",
    footer_hours1: "Lun – Sab · 09:00 – 12:45 / 17:30 – 20:00",
    footer_hours2: "Lunedì mattina chiuso · Domenica chiuso",
    footer_admin: "Area riservata",
    footer_rights: "Tutti i diritti riservati",
    footer_banner: "Nel cuore bianco della Valle d'Itria",
    footer_banner_alt: "Vicolo di Ceglie Messapica al tramonto",
    wa_label: "Scrivici ora",
    cart_title: "Il tuo carrello",
    cart_empty: "Il carrello è vuoto. Scegli una montatura dalla vetrina.",
    cart_total: "Totale",
    cart_ph_note: "Note (facoltativo)",
    cart_submit: "Conferma e invia su WhatsApp",
    cart_sending: "Invio in corso…",
    cart_note: "Il pagamento si concorda in negozio o su WhatsApp. Nessun pagamento online richiesto.",
    cart_toast_ok: "Ordine registrato! Si è aperto WhatsApp con il riepilogo: invialo per confermare.",
    cart_toast_err: "Errore nell'invio dell'ordine. Riprova.",
    cart_close: "Chiudi",
    cart_minus: "Diminuisci",
    cart_plus: "Aumenta",
    cart_remove: "Rimuovi",
    cart_open: "Carrello",
    faq_overline: "05 · Domande frequenti",
    faq_overline_plain: "Domande frequenti",
    faq_title: "Le risposte che cerchi.",
    faqs: [
      { q: "Serve prenotare per provare gli occhiali?", a: "No: puoi passare quando vuoi negli orari di apertura e provare liberamente le montature. Se preferisci una consulenza dedicata, prenota una visita e ti dedicheremo tutto il tempo che serve." },
      { q: "Fate la misurazione della vista in negozio?", a: "Sì, eseguiamo la misurazione della vista direttamente in negozio. Come Centro Ottico Expert Specialist Essilor seguiamo un protocollo accurato, per lenti perfette fin dal primo utilizzo." },
      { q: "Quanto tempo serve per ricevere gli occhiali?", a: "Nella maggior parte dei casi pochi giorni lavorativi. Per lenti particolari o trattamenti speciali i tempi possono variare: ti daremo sempre una data precisa al momento dell'ordine." },
      { q: "Avete occhiali per bambini?", a: "Sì, siamo specializzati in lenti oftalmiche per i più piccoli e siamo certificati per la gestione della miopia con lenti Stellest. Seguiamo ogni bambino nel tempo, con controlli periodici." },
      { q: "Posso ordinare online e ritirare in negozio?", a: "Sì: scegli i modelli dalla vetrina, conferma l'ordine su WhatsApp e passa a ritirarli quando vuoi. Se preferisci, consegniamo anche a domicilio." },
      { q: "Quali metodi di pagamento accettate?", a: "In negozio accettiamo contanti, bancomat e carte di credito. Per gli ordini online il pagamento si concorda su WhatsApp o direttamente al ritiro." },
    ],
    book_overline: "06 · Prenota una visita",
    book_title: "Prenota il tuo appuntamento.",
    book_sub: "Scegli il giorno e l'orario che preferisci: puoi prenotare da 2 giorni in poi, così ci organizziamo per accoglierti al meglio. Ti confermeremo l'appuntamento al più presto.",
    book_phone: "Telefono",
    book_service: "Servizio",
    book_service_ph: "Scegli un servizio",
    svc_vista: "Misurazione della vista",
    svc_occhiali: "Consulenza occhiali da vista",
    svc_sole: "Occhiali da sole",
    svc_bambini: "Lenti per bambini · gestione miopia",
    svc_progressive: "Lenti progressive",
    svc_altro: "Altro",
    svc_lenti_prima: "Prima applicazione lenti a contatto",
    svc_lenti_controllo: "Controllo / rinnovo lenti a contatto",
    book_ambito: "Per cosa ci vediamo?",
    book_ambito_first: "Scegli prima il reparto",
    ambito_vista: "Occhiali da Vista",
    ambito_vista_sub: "Vista & lenti oftalmiche",
    ambito_lenti: "Lenti a Contatto",
    ambito_lenti_sub: "Applicazione & controllo",
    book_banner_overline: "Il tuo sguardo, seguito con cura",
    book_banner_title: "Prenota la tua visita.",
    book_banner_sub: "Misurazione della vista, occhiali da vista o applicazione delle lenti a contatto: fissa un appuntamento e ti dedicheremo tutto il tempo che serve.",
    book_banner_cta: "Prenota ora",
    spec_lenti: "Lenti",
    spec_taglia: "Taglia",
    book_date: "Giorno",
    book_slot: "Orario",
    book_submit: "Richiedi appuntamento",
    book_sending: "Invio in corso…",
    book_sunday: "La domenica siamo chiusi: scegli un altro giorno.",
    book_monday: "Il lunedì siamo aperti solo il pomeriggio (17:30 – 20:00).",
    book_toast_ok: "Richiesta registrata! Si è aperto WhatsApp con il riepilogo: invialo per confermare la prenotazione.",
    book_toast_err: "Errore nell'invio. Riprova o chiamaci allo 0831 19 81 780.",
    privacy_note: "Inviando accetti la nostra",
    privacy_link: "informativa privacy",
    book_consent: "Ho letto e accetto il trattamento dei miei dati per gestire la richiesta di appuntamento, secondo l'",
    tryon_btn: "Prova virtuale",
    tryon_title: "Prova virtuale",
    tryon_sub: "Guarda come ti sta",
    tryon_use_camera: "Scatta un selfie",
    tryon_use_upload: "Carica una foto",
    tryon_capture: "Scatta",
    tryon_cancel: "Annulla",
    tryon_start: "Vedi gli occhiali su di me",
    tryon_change: "Cambia foto",
    tryon_loading: "L'AI sta applicando gli occhiali sul tuo volto… può richiedere un minuto.",
    tryon_retry: "Prova un'altra foto",
    tryon_done: "Fatto",
    tryon_mode_single: "Questo modello",
    tryon_mode_compare: "Confronta montature",
    tryon_pick_sub: "Scegli da 2 a 4 montature da provare insieme sul tuo viso:",
    tryon_pick_min: "Seleziona almeno 2 montature da confrontare",
    tryon_compare_start: "Confronta sul mio viso",
    tryon_compare_loading: "L'AI sta applicando tutte le montature sul tuo viso... può richiedere circa un minuto.",
    tryon_download: "Scarica",
    tryon_added: "Aggiunto al carrello",
    tryon_error: "Prova virtuale non riuscita. Riprova con un'altra foto.",
    tryon_camera_err: "Fotocamera non disponibile: carica una foto.",
    tryon_privacy: "La tua foto viene usata solo per generare l'anteprima e non viene salvata né condivisa.",
    tryon_result_alt: "Anteprima degli occhiali sul tuo volto",
    hl_1: "Optometristi certificati",
    hl_2: "Specializzati in ottica per bambini",
    hl_3: "Lenti progressive",
    hl_4: "Brand di nicchia",
    chi_overline: "Chi siamo",
    chi_photo_alt: "I titolari di Stylottica Ceglie nella loro boutique",
    v2_nav_collezioni: "Collezioni",
    v2_nav_storia: "La nostra storia",
    v2_nav_prodotti: "Prodotti",
    v2_nav_contatti: "Contatti",
    v2_hero_overline: "Ottica · Ceglie Messapica",
    v2_hero_suffix: " · dal 2012",
    v2_hero_title: "L'arte di vedere bene.",
    v2_hero_sub: "Nel cuore bianco di Ceglie Messapica, dal 2012: occhiali da sole di carattere da scegliere anche online, e una cura della vista che si costruisce insieme, con calma, su appuntamento.",
    v2_hero_cta: "Scopri le collezioni",
    v2_coll_overline: "Le collezioni",
    v2_coll_sole_desc: "Protezione UV totale e carattere da vendere. Li scegli online e li ritiri in negozio — oppure te li consegniamo a casa.",
    v2_coll_vista_desc: "La vista è una cosa seria: si misura con calma, con gli strumenti giusti. Prenota la tua visita e costruiamo insieme le tue lenti.",
    v2_scopri: "Scopri",
    v2_storia_overline: "La nostra storia",
    v2_storia_title: "Tredici anni di sguardi.",
    v2_storia_p1: "Tutto è iniziato tredici anni fa, in una via del centro di Ceglie Messapica. Da allora, ogni giorno, accogliamo chi entra come fosse di casa: prima ascoltiamo le tue giornate, i tuoi occhi, le tue abitudini — poi consigliamo. Perché l'occhiale giusto cambia il modo in cui vedi il mondo, e in cui il mondo vede te.",
    v2_storia_p2: "Siamo optometristi certificati e Centro Ottico Expert Specialist Essilor. Ci prendiamo cura della vista dei più piccoli con la gestione certificata della miopia e le lenti Stellest, costruiamo lenti progressive su misura per le tue giornate e scegliamo brand di nicchia che altrove non trovi — con la stessa cura con cui sceglieremmo per noi.",
    v2_quote: "Professionalità ed empatia la fanno da padrone.",
    v2_mission_label: "La nostra missione",
    v2_mission: "Occhiali per chi sceglie di essere unico. Mai low cost, mai noioso.",
    v2_stat1: "Anni di attività",
    v2_stat2: "Certificazioni ottiche",
    v2_stat3: "Su Google",
    v2_prod_overline: "I prodotti",
    v2_prod_sub: "I nostri occhiali da sole, scelti uno a uno dai brand di nicchia che amiamo: ordinali online e passa a ritirarli quando vuoi, oppure scrivici su WhatsApp. Per gli occhiali da vista, invece, ci vediamo di persona — la tua vista merita più di un click.",
    v2_prod_cta: "Chiedi disponibilità",
    v2_coll_overline: "Le collezioni",
    v2_coll_instore: "Solo in negozio",
    v2_empty: "La vetrina si sta riempiendo. Torna presto a trovarci.",
    v2_show_all: "Vedi tutti i prodotti",
    v2_show_less: "Mostra meno",
    v2_version1: "Versione 1",
    v2_version2: "Versione 2",
  },
  en: {
    nav_servizi: "Services",
    nav_brand: "Brands",
    nav_recensioni: "Reviews",
    nav_contatti: "Contact",
    nav_faq: "FAQ",
    cta_prenota: "Book a Visit",
    hero_overline: "Opticians · Ceglie Messapica",
    hero_l1: "Style",
    hero_l2a: "meets",
    hero_l2b: "vision.",
    hero_sub: "For over 13 years the go-to opticians in the heart of the Itria Valley: sunglasses, prescription glasses, children's lenses and progressive lenses. Via Cristoforo Colombo 40, Ceglie Messapica.",
    hero_cta1: "Book a visit",
    hero_cta_shop: "Explore the Collection",
    hero_cta2: "Discover our services",
    hero_proof: "5.0 on Google · 35 reviews",
    cfg_shape: "Frame",
    cfg_color: "Colour",
    cfg_lens: "Lenses",
    shape_rotonda: "Round",
    shape_squadrata: "Square",
    shape_pantos: "Panto",
    shape_aviator: "Aviator",
    shape_cateye: "Cat-eye",
    col_nero: "Black",
    col_avana: "Havana",
    col_terracotta: "Terracotta",
    col_oliva: "Olive",
    col_oro: "Gold",
    lens_cristallo: "Crystal",
    lens_verde: "Green",
    lens_ambra: "Amber",
    lens_fume: "Smoke",
    lens_azzurra: "Light blue",
    man_statement: "Eyewear for those who choose to be unique.",
    man_highlight: "unique.",
    man_c1t: "Thirteen years in the area",
    man_c1d: "For over thirteen years in Ceglie Messapica: a benchmark opticians where professionalism and empathy rule.",
    man_c2t: "Vision specialists",
    man_c2d: "Ophthalmic lenses for children with certified myopia management, and progressive lenses for adults: vision at every age.",
    man_c3t: "Carefully chosen brands and spaces",
    man_c3d: "Our choice of brands and interior design is our strength: everything is designed for those who want to feel unique.",
    man_alt: "Editorial portrait with prescription glasses",
    cert_label: "Certifications",
    cert1t: "Expert Specialist Optical Centre",
    cert2t: "Certified myopia management",
    srv_overline: "01 · Our services",
    srv_title: "Everything for your eyes, in one place.",
    srv1t: "Sunglasses",
    srv1d: "Carefully selected adult collections: from timeless classics to the latest trends.",
    srv2t: "Prescription glasses",
    srv2d: "Frames and ophthalmic lenses made to measure, with absolute attention to precision.",
    srv3t: "Children's lenses",
    srv3d: "Ophthalmic lenses for the little ones and certified myopia management with Stellest lenses.",
    srv4t: "Progressive lenses",
    srv4d: "For adults: a smooth transition between near and far, with no compromises.",
    srv5t: "Delivery and pick-up",
    srv5d: "Home delivery or in-store pick-up: whichever you prefer, without waiting.",
    srv_store_t: "In-store shopping",
    srv_store_d: "Come and visit us: try on frames with advice from our opticians. Quick visit, no obligation.",
    srv_store_alt: "Inside the Stylottica Ceglie boutique",
    stmt_label: "Our philosophy",
    stmt_w1: "Better",
    stmt_w2: "unique",
    stmt_w3: "than boring.",
    brand_overline: "02 · Brands & Styles",
    brand_title: "The frames you love, for youngsters too.",
    brand_sub: "At Stylottica Ceglie you'll find Police glasses designed for teenagers and many more options for every age and style.",
    mq_sole: "Sunglasses",
    mq_vista: "Eyeglasses",
    mq_contatto: "Contact Lenses",
    mq_teen: "Teen Frames",
    mq_nuove: "New Collections",
    vet_overline: "03 · Showcase",
    vet_title: "The frames of the moment.",
    vet_sub: "A selection of the models available in store. Choose a collection and come try them on.",
    vet_all: "All",
    vet_empty: "No models in this collection for now. Come back soon.",
    vet_add: "Add to cart",
    vet_out: "Sold out",
    vet_unavailable: "Unavailable",
    vet_avail: "Available in store",
    vet_last: "Only {n} left",
    vet_last1: "Last one left",
    promo_label: "Current promotion",
    promo_cta: "Take advantage in store",
    promo_valid: "Valid until",
    promo_da: "Valid from",
    rev_overline: "04 · What they say about us",
    rev_caption: "The full score from our customers on Google",
    rev_stat1: "Google · 35 reviews",
    rev_stat2: "Facebook · 46 reviews",
    rev_stat3: "Facebook followers",
    rev_closing: "Our customers' trust is our finest lens. Come visit us and discover why whoever walks into Stylottica Ceglie always comes back.",
    testimonials: [
      { text: "Rare professionalism and kindness. They helped me choose the perfect frame for my face.", name: "Maria G." },
      { text: "Glasses ready in no time and an impeccable result. I will definitely be back.", name: "Giuseppe L." },
      { text: "Finally an optician who truly listens. Extremely accurate eye test.", name: "Anna S." },
      { text: "I got Police glasses for my son: he's thrilled and never takes them off.", name: "Francesca M." },
      { text: "Honest prices, plenty of choice and sincere advice. Highly recommended.", name: "Marco P." },
      { text: "Elegant environment and super-prepared staff. The best optician in the area.", name: "Lucia R." },
    ],
    con_overline: "07 · Contact & Opening hours",
    con_directions: "Get directions",
    con_title: "We look forward to seeing you in store.",
    con_hours: "Opening hours",
    day_mon: "Monday",
    day_tuesat: "Tuesday – Saturday",
    day_sun: "Sunday",
    mon_note: "Closed in the morning",
    closed: "Closed",
    con_phone_note: "(also on WhatsApp)",
    con_form_t: "Send us a message",
    con_form_s: "To book a visit or ask about our collections.",
    ph_name: "Full name",
    ph_phone: "Phone (optional)",
    ph_msg: "Your message",
    btn_send: "Send message",
    btn_sending: "Sending…",
    toast_ok: "Message sent! We'll get back to you as soon as possible.",
    toast_err: "Sending failed. Try again or call us on 0831 19 81 780.",
    footer_tag: "Opticians in Ceglie Messapica. Via Cristoforo Colombo 40, 72013 (BR).",
    footer_hours1: "Mon – Sat · 09:00 – 12:45 / 17:30 – 20:00",
    footer_hours2: "Closed Monday morning · Closed Sunday",
    footer_admin: "Staff area",
    footer_rights: "All rights reserved",
    footer_banner: "In the white heart of the Itria Valley",
    footer_banner_alt: "Alley of Ceglie Messapica at sunset",
    wa_label: "Message us",
    cart_title: "Your cart",
    cart_empty: "Your cart is empty. Choose a frame from the showcase.",
    cart_total: "Total",
    cart_ph_note: "Notes (optional)",
    cart_submit: "Confirm and send via WhatsApp",
    cart_sending: "Sending…",
    cart_note: "Payment is arranged in store or on WhatsApp. No online payment required.",
    cart_toast_ok: "Order registered! WhatsApp has opened with the summary: send it to confirm.",
    cart_toast_err: "Error sending the order. Please try again.",
    cart_close: "Close",
    cart_minus: "Decrease",
    cart_plus: "Increase",
    cart_remove: "Remove",
    cart_open: "Cart",
    faq_overline: "05 · Frequently asked questions",
    faq_overline_plain: "Frequently asked questions",
    faq_title: "The answers you're looking for.",
    faqs: [
      { q: "Do I need to book to try on glasses?", a: "No: drop by anytime during opening hours and try on frames freely. If you'd like a dedicated consultation, book a visit and we'll give you all the time you need." },
      { q: "Do you offer eye tests in store?", a: "Yes, we carry out sight tests directly in store. As an Essilor Expert Specialist Optical Centre we follow an accurate protocol, for perfect lenses from the very first wear." },
      { q: "How long does it take to get my glasses?", a: "In most cases just a few working days. For special lenses or treatments times may vary: we'll always give you a precise date when you order." },
      { q: "Do you have glasses for children?", a: "Yes, we specialise in ophthalmic lenses for the little ones and we are certified for myopia management with Stellest lenses. We follow each child over time, with regular check-ups." },
      { q: "Can I order online and pick up in store?", a: "Yes: choose your frames from the showcase, confirm the order on WhatsApp and pick them up whenever you like. Home delivery is also available." },
      { q: "Which payment methods do you accept?", a: "In store we accept cash, debit and credit cards. For online orders, payment is arranged on WhatsApp or at pick-up." },
    ],
    book_overline: "06 · Book a visit",
    book_title: "Book your appointment.",
    book_sub: "Choose the day and time you prefer: you can book from 2 days ahead, so we can organise ourselves to welcome you at our best. We'll confirm your appointment as soon as possible.",
    book_phone: "Phone",
    book_service: "Service",
    book_service_ph: "Choose a service",
    svc_vista: "Sight test",
    svc_occhiali: "Prescription glasses consultation",
    svc_sole: "Sunglasses",
    svc_bambini: "Children's lenses · myopia management",
    svc_progressive: "Progressive lenses",
    svc_altro: "Other",
    svc_lenti_prima: "First contact lens fitting",
    svc_lenti_controllo: "Contact lens check / renewal",
    book_ambito: "What can we help with?",
    book_ambito_first: "Choose the department first",
    ambito_vista: "Prescription Glasses",
    ambito_vista_sub: "Sight test & eyewear",
    ambito_lenti: "Contact Lenses",
    ambito_lenti_sub: "Fitting & check-up",
    book_banner_overline: "Your eyes, in caring hands",
    book_banner_title: "Book your visit.",
    book_banner_sub: "Sight test, prescription glasses or contact lens fitting: book an appointment and we'll give you all the time you need.",
    book_banner_cta: "Book now",
    spec_lenti: "Lenses",
    spec_taglia: "Size",
    book_date: "Day",
    book_slot: "Time",
    book_submit: "Request appointment",
    book_sending: "Sending…",
    book_sunday: "We're closed on Sundays: please choose another day.",
    book_monday: "On Mondays we're open in the afternoon only (17:30 – 20:00).",
    book_toast_ok: "Request registered! WhatsApp has opened with the summary: send it to confirm your booking.",
    book_toast_err: "Sending failed. Try again or call us on 0831 19 81 780.",
    privacy_note: "By sending you accept our",
    privacy_link: "privacy policy",
    book_consent: "I have read and accept the processing of my data to handle the appointment request, according to the",
    tryon_btn: "Virtual try-on",
    tryon_title: "Virtual try-on",
    tryon_sub: "See how they look on you:",
    tryon_use_camera: "Take a selfie",
    tryon_use_upload: "Upload a photo",
    tryon_capture: "Capture",
    tryon_cancel: "Cancel",
    tryon_start: "See the glasses on me",
    tryon_change: "Change photo",
    tryon_loading: "The AI is applying the glasses to your face… it can take up to a minute.",
    tryon_retry: "Try another photo",
    tryon_done: "Done",
    tryon_mode_single: "This frame",
    tryon_mode_compare: "Compare frames",
    tryon_pick_sub: "Pick 2 to 4 frames to try on your face together:",
    tryon_pick_min: "Select at least 2 frames to compare",
    tryon_compare_start: "Compare on my face",
    tryon_compare_loading: "The AI is applying every frame to your face... this can take about a minute.",
    tryon_download: "Download",
    tryon_added: "Added to cart",
    tryon_error: "Virtual try-on failed. Please try another photo.",
    tryon_camera_err: "Camera not available: please upload a photo.",
    tryon_privacy: "Your photo is only used to generate the preview and is never stored or shared.",
    tryon_result_alt: "Preview of the glasses on your face",
    hl_1: "Certified optometrists",
    hl_2: "Children's eyewear specialists",
    hl_3: "Progressive lenses",
    hl_4: "Niche brands",
    chi_overline: "About us",
    chi_photo_alt: "The owners of Stylottica Ceglie in their boutique",
    v2_nav_collezioni: "Collections",
    v2_nav_storia: "Our story",
    v2_nav_prodotti: "Products",
    v2_nav_contatti: "Contact",
    v2_hero_overline: "Opticians · Ceglie Messapica",
    v2_hero_suffix: " · since 2012",
    v2_hero_title: "The art of seeing well.",
    v2_hero_sub: "In the whitewashed heart of Ceglie Messapica, since 2012: sunglasses with character you can also buy online, and eye care built together, calmly, by appointment.",
    v2_hero_cta: "Discover the collections",
    v2_coll_overline: "The collections",
    v2_coll_sole_desc: "Full UV protection and plenty of character. Choose them online, pick them up in store — or we'll deliver them to your door.",
    v2_coll_vista_desc: "Vision is a serious matter: it's measured calmly, with the right instruments. Book your visit and we'll build your lenses together.",
    v2_scopri: "Explore",
    v2_storia_overline: "Our story",
    v2_storia_title: "Thirteen years of gazes.",
    v2_storia_p1: "It all began thirteen years ago, on a street in the centre of Ceglie Messapica. Since then, every single day, we welcome whoever walks in like family: first we listen to your days, your eyes, your habits — then we advise. Because the right pair of glasses changes the way you see the world, and the way the world sees you.",
    v2_storia_p2: "We are certified optometrists and an Essilor Expert Specialist Optical Centre. We care for children's vision with certified myopia management and Stellest lenses, we craft progressive lenses tailored to your days, and we choose niche brands you won't find elsewhere — with the same care we would choose for ourselves.",
    v2_quote: "Professionalism and empathy rule here.",
    v2_mission_label: "Our mission",
    v2_mission: "Eyewear for those who choose to be unique. Never low-cost, never boring.",
    v2_stat1: "Years in business",
    v2_stat2: "Optical certifications",
    v2_stat3: "On Google",
    v2_prod_overline: "The products",
    v2_prod_sub: "Our sunglasses, hand-picked from the niche brands we love: order online and pick them up whenever you like, or message us on WhatsApp. For prescription glasses, instead, we meet in person — your sight deserves more than a click.",
    v2_prod_cta: "Ask availability",
    v2_coll_overline: "The collections",
    v2_coll_instore: "In-store only",
    v2_empty: "The showcase is filling up. Come back soon.",
    v2_show_all: "See all products",
    v2_show_less: "Show less",
    v2_version1: "Version 1",
    v2_version2: "Version 2",
  },
  de,
  fr,
};

export const LANGS = [
  { id: "it", label: "IT", name: "Italiano" },
  { id: "en", label: "EN", name: "English" },
  { id: "de", label: "DE", name: "Deutsch" },
  { id: "fr", label: "FR", name: "Français" },
];

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("oc-lang");
    if (LANGS.some((l) => l.id === saved)) return saved;
    const nav = (navigator.language || "it").toLowerCase().slice(0, 2);
    return LANGS.some((l) => l.id === nav) ? nav : "en";
  });

  useEffect(() => {
    localStorage.setItem("oc-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => STRINGS[lang]?.[key] ?? STRINGS.it[key] ?? key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
